/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoTraceCandidate
 */
export interface OutputGeoTraceCandidate {
    /**
     * Chosen — саме цього кандидата взяла переможна гіпотеза.
     * @type {boolean}
     * @memberof OutputGeoTraceCandidate
     */
    chosen?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTraceCandidate
     */
    displayName?: string;
    /**
     * DistToAnchorKm — відстань до якоря (центру коридору), за яким робилась вибірка.
     * @type {number}
     * @memberof OutputGeoTraceCandidate
     */
    distToAnchorKm?: number;
    /**
     * ExcessKm — на скільки км кандидат вилітає за коридор старт↔ціль (0 = всередині).
     * @type {number}
     * @memberof OutputGeoTraceCandidate
     */
    excessKm?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCandidate
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCandidate
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCandidate
     */
    placeId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCandidate
     */
    score?: number;
    /**
     * Viable — score пройшов поріг MinScore. Непрохідні теж віддаємо: «НП у газетирі є, але
     * назва не дотягнула» — принципово інший діагноз, ніж «такого НП немає взагалі».
     * @type {boolean}
     * @memberof OutputGeoTraceCandidate
     */
    viable?: boolean;
}

/**
 * Check if a given object implements the OutputGeoTraceCandidate interface.
 */
export function instanceOfOutputGeoTraceCandidate(value: object): boolean {
    return true;
}

export function OutputGeoTraceCandidateFromJSON(json: any): OutputGeoTraceCandidate {
    return OutputGeoTraceCandidateFromJSONTyped(json, false);
}

export function OutputGeoTraceCandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceCandidate {
    if (json == null) {
        return json;
    }
    return {
        
        'chosen': json['chosen'] == null ? undefined : json['chosen'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'distToAnchorKm': json['distToAnchorKm'] == null ? undefined : json['distToAnchorKm'],
        'excessKm': json['excessKm'] == null ? undefined : json['excessKm'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
        'score': json['score'] == null ? undefined : json['score'],
        'viable': json['viable'] == null ? undefined : json['viable'],
    };
}

export function OutputGeoTraceCandidateToJSON(value?: OutputGeoTraceCandidate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'chosen': value['chosen'],
        'displayName': value['displayName'],
        'distToAnchorKm': value['distToAnchorKm'],
        'excessKm': value['excessKm'],
        'lat': value['lat'],
        'lon': value['lon'],
        'placeId': value['placeId'],
        'score': value['score'],
        'viable': value['viable'],
    };
}

